import clsx from 'clsx';
import { KeyboardEvent, MouseEvent, useCallback } from 'react';

import { KeyCode } from '@vestico/utils';

import style from './close.module.css';

export enum CloseButtonSize {
  small = 0,
  medium,
}

export interface CloseButtonProps {
  title: string;
  onClick?: () => void;
  size: CloseButtonSize;
  color?: 'dark' | 'bright';
}

export const CloseButton = (props: CloseButtonProps) => {
  const { title, size, onClick, color } = props;

  const passOnClick = useCallback(
    (e: MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault();

      if (onClick) {
        onClick();
      }
      return false;
    },
    [onClick]
  );

  const handleKeyUp = useCallback(
    (e: KeyboardEvent<HTMLAnchorElement>) => {
      e.preventDefault();
      e.stopPropagation();

      if (e.code === KeyCode.enter && onClick) {
        onClick();
        e.currentTarget.blur();
      }
    },
    [onClick]
  );

  return (
    // skipcq JS-0738
    <a
      onClick={passOnClick}
      className={clsx(style.close, { [style.small]: size === CloseButtonSize.small, [style.dark]: color === undefined || color === 'dark' })}
      title={title}
      onKeyUp={handleKeyUp}
      tabIndex={0}
      role="button"
    />
  );
};

export default CloseButton;
